import { FormattedUnitLabels, FormatterInput } from '@/helpers/unit-formatter/shared/types';
import {
  formatNumber,
  toNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/shared/utils';

/**
 * Formatter for values that should never render a unit suffix.
 * Numeric values use standard precision formatting; non-numeric values pass through.
 */
export const formatUnitless = ({ value }: FormatterInput): FormattedUnitLabels => {
  const numeric = toNumber(value);

  if (numeric == null) {
    return unitValueToFormattedUnitLabels({ value, units: undefined });
  }

  return unitValueToFormattedUnitLabels({
    value: formatNumber(numeric),
    units: undefined,
  });
};
